import { render, staticRenderFns } from "./chatForm.vue?vue&type=template&id=8ebaf06a&scoped=true&"
import script from "./chatForm.vue?vue&type=script&lang=js&"
export * from "./chatForm.vue?vue&type=script&lang=js&"
import style0 from "./chatForm.vue?vue&type=style&index=0&id=8ebaf06a&prod&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ebaf06a",
  null
  
)

export default component.exports